const PT = 'pt_PT';
const EN = 'en_GB';

export default {
  PT: PT,
  EN: EN
};
